var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopilotChat = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 187,
  height: 187,
  viewBox: "0 0 187 187",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M187 93.5C187 145.139 145.139 187 93.5 187C41.8614 187 0 145.139 0 93.5C0 41.8614 41.8614 0 93.5 0C145.139 0 187 41.8614 187 93.5Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M66.7933 127.953L50.3583 144.256L52.2547 118.109L47.2024 107.228C41.0977 94.0802 42.1381 78.7243 49.9604 66.5204V66.5204C55.7034 57.5605 64.6079 51.0899 74.9036 48.3953L82.7064 46.353C91.7378 43.9893 101.238 44.0954 110.215 46.6603L114.322 47.8338C124.971 50.8767 133.976 58.023 139.359 67.7024L139.878 68.6353C145.993 79.6301 146.529 92.8735 141.325 104.327V104.327C137.291 113.203 130.13 120.282 121.209 124.214L115.367 126.789C106.321 130.776 96.3861 132.315 86.5578 131.252L73.1144 129.798L83.8603 83.6555L91.7617 107.65L100.295 64.2755L108.829 95.9603L115.782 76.8879L121.155 99.6517",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopilotChat);
export { ForwardRef as ReactComponent };